/* global digitalData, createPageviewTagForSPA */
// See https://pages.github.ibm.com/digital-behavior/docs/tms-spa.html for notes on SPA integration
exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;
  digitalData.page.pageInfo.pageID = location.pathname;
  createPageviewTagForSPA && createPageviewTagForSPA();
};
